import { clientConstantsServiceInstance } from "../../services/client-constants/client-constants.service.instance";

export function useClientConstants() {
  function getValueOrDefault(key: string, defaultValue: string): string {
    return clientConstantsServiceInstance.getClientConstantValueOrDefault({
      key,
      default: defaultValue,
    });
  }

  return {
    getValueOrDefault,
  };
}
